
import Editor from "@toast-ui/editor";
import "@toast-ui/editor/dist/toastui-editor.css";
import { defineComponent, onMounted, ref } from "vue";
import { Ref } from "@vue/runtime-core";

export default defineComponent({
  props: {
    modelValue: {
      type: String,
      required: false,
      default: "",
    },
    label: {
      type: String,
    },
    required: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    }
  },
  emits: ["update:modelValue"],

  setup(props, { emit }) {
    const editor = ref();
    const editorDiv = ref();

    const modelValue = ref(props.modelValue);

    const toolbarOptions = [
      ["heading", "bold", "italic", "strike"],
      ["hr", "quote"],
      ["ul", "ol", "task"],
      ["table", "link"],
      ["code", "codeblock"],
    ];

    onMounted(async () => {
      createEditor(toolbarOptions, modelValue.value);
    });

    const createEditor = (toolbarOptions, value: string) => {
      editor.value = new Editor({
        el: editorDiv.value,
        height: "200px",
        initialEditType: "wysiwyg",
        previewStyle: "vertical",
        hideModeSwitch: false,
        placeholder: "Escreva aqui...",
        initialValue: value,
        toolbarItems: toolbarOptions,
        events: {
          change: () => emit("update:modelValue", editor.value.getMarkdown()),
        },
      });

      handleDisabledEditor()
    };

    const handleDisabledEditor = () => {
      if (props.disabled) {
        const [viewerDiv, markdownDiv] = document.getElementsByClassName("ProseMirror") as HTMLCollectionOf<HTMLDivElement>;
        viewerDiv.contentEditable = "false";
        markdownDiv.contentEditable = "false";
      }
    }

    return {
      editor,
      editorDiv,
    };
  },
});
